import { Component } from '@angular/core';

@Component({
  selector: 'app-about-page',
  template: `
    <app-page-section
      backgroundColor="secondary"
      [waves]="true"
      [noContainer]="true"
    >
      <div class="container max-w-3xl text-center">
        <div class="flex items-center space-x-2">
          <i class="fal fa-stars text-white"></i>
          <div class="h-px w-24 bg-white"></div>
        </div>
        <div class="text-center text-white">
          <h1 class="mt-6">Comment nos clients utilisent le produit&nbsp;?</h1>
          <p class="mt-8 text-lg text-balance"
            >Voici quelques exemples de l'utilisation de la solution web
            location-salles.ch parmi nos clients&nbsp;:</p
          >
        </div>
      </div>

      <div class="container">
        <div class="mt-8 flex flex-wrap justify-center gap-6">
          <a [routerLink]="['/louer-salle']">
            <app-button>Voir l'annuaire</app-button>
          </a>
        </div>
      </div>
    </app-page-section>

    <div class="pt-16 xl:pt-0"></div>

    <app-page-section padding="sm">
      <app-feature-section [imageFirst]="true" scrollTriggerStart="top 100%">
        <img
          src="/assets/img/garder-le-controle.svg"
          alt="Contrôle des réservations"
          title="Contrôle des réservations"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>contrôle</app-public-tag>
          <h2>Gardez le contrôle sur les réservations de vos clients</h2>
          <p
            >Vos clients font des <b>demandes de réservation</b> et paient leur
            réservation en ligne. Plus besoin d'effectuer un suivi des paiements
            !</p
          >
          <p
            >Vous êtes ensuite notifiés et pouvez approuver ou refuser la
            demande. En cas de refus, le client est automatiquement
            remboursé.</p
          >
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section>
      <app-feature-section>
        <img
          src="/assets/img/location-heure-journee.svg"
          alt="Location de salles - Location à l'heure ou à la journée"
          title="Location de salles - Location à l'heure ou à la journée"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>grande flexibilité</app-public-tag>
          <h2
            >Location de salles à l'heure<br />et
            <span class="text-primary-500">/</span> ou à la journée</h2
          >
          <p
            >Vos clients souhaitent effectuer une réservation de salle pour une
            réunion ponctuelle, avec ou sans récurrence, pour laquelle vous avez
            un tarif horaire spécifique à leur proposer ?</p
          >
          <p
            >Tout peut être géré par notre plateforme qui permet à la fois cette
            grande flexibilité, et l’automatisation de tous les processus
            complexes qui s’ensuivent.</p
          >
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section padding="sm">
      <app-feature-section [imageFirst]="true">
        <img
          src="/assets/img/gestion-des-salles.svg"
          alt="Location de salles - Gestion des salles"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>configuration autonome</app-public-tag>
          <h2>Gestion des salles A à Z</h2>
          <p
            >Vous créez et gérez vos salles de A à Z : tarification à l'heure ou
            à la journée, temps de pause entre location, horaires possibles,
            délai de réservation à l’avance, ajout d’équipements inclus/en sus,
            ajout de photos et de visite virtuelle, etc.</p
          >
          <p
            >Ceci permet à vos clients d’être renseignés comme il se doit, et
            évite qu’ils prennent directement contact avec vous en raison du
            manque d’informations.</p
          >
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section padding="sm">
      <app-feature-section>
        <img
          src="/assets/img/louer-groupe-de-salles.svg"
          alt="Location de salles - Groupe de salles (objets liés)"
          title="Location de salles - Groupe de salles (objets liés)"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>location d'espaces liés</app-public-tag>
          <h2>Louer un groupe de salles, c'est possible</h2>
          <p
            >Un groupe de salles permet à vos clients de réserver plusieurs
            salles d’un même bâtiment en une seule réservation.</p
          >
          <p
            >Du côté admin, vous pouvez empêcher que des clients différents
            réservent des salles au même moment. Vous pouvez définir une
            tarification spéciale pour ces groupes.</p
          >
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section padding="sm">
      <app-feature-section [imageFirst]="true">
        <img
          src="/assets/img/solution-collaborative.svg"
          alt="Location de salles - Solution collaborative"
          title="Location de salles - Solution collaborative"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>collaboration</app-public-tag>
          <h2>Une solution collaborative pour vos employés</h2>
          <p
            >Souvent, la location de salles implique plusieurs collaborateurs et
            les infos circulent difficilement dû à l’utilisation d’outils qui ne
            sont pas destinés cet usage.</p
          >
          <p
            >Location-salles.ch vous permet d’automatiser et cibler la
            notification de vos collègues, ou encore de gérer des accès
            administrateurs avec différents niveaux de droit.</p
          >
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section padding="sm">
      <app-feature-section>
        <img
          src="/assets/img/outil-accessible.svg"
          alt="Location de salles - Outil accessible"
          title="Location de salles - Outil accessible"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>accessibilité</app-public-tag>
          <h2>Un outil accessible sur tous vos supports</h2>
          <p
            >L’outil location-salles.ch est accessibles sur tous supports
            (smartphone, tablette, ordinateur) et a été conçu pour être
            utilisable autant au bureau qu’en déplacement.
          </p>
          <p
            >Une interface moderne basée sur les besoins des utilisateurs
            d’aujourd’hui et de demain font de cet outil une solution durable
            sur le long terme.</p
          >
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section>
      <div class="flex justify-center">
        <app-button routerLink="/tarifs" icon="arrow-right"
          >Découvrir nos offres</app-button
        >
      </div>
    </app-page-section>

    <app-page-section
      padding="lg"
      [noContainer]="true"
      [waves]="true"
      backgroundColor="secondary"
      offsetImage="cactus.png"
    >
      <div class="container text-right">
        <div class="mx-auto max-w-[800px]">
          <blockquote class="text-3xl font-medium text-white">
            "location-salles.ch a permis à toutes les personnes impliquées dans
            le processus de leur libérer un temps considérable pour se dédier à
            d'autres tâches."
          </blockquote>
          <div class="mt-6">
            <app-public-tag
              >Secrétariat municipal, Commune d'Echallens</app-public-tag
            >
          </div></div
        >
      </div>
    </app-page-section>

    <div class="h-20 bg-white"></div>
  `,
  standalone: false,
})
export class AboutPageComponent {}
